import Slideshow from './slideshow';

export default class SlideshowDesktop extends Slideshow {
    constructor(...args) {
        super(...args);
    }

    /*
    init() {
    }
    bind() {
    }
    unbind() {
    }
    resize(width, height) {
    }
    */
}



// WEBPACK FOOTER //
// ./src/js/components/slideshow/slideshow.desktop.js